import { Project } from 'src/modules/common/types/Project';
import { ProjectEventDescriptor } from 'src/modules/project-event/types/ProjectEventDescriptor';
import { createTrigger } from 'src/utils/createTrigger';

export const PROJECT_EVENT_SEND = createTrigger<ProjectEventDescriptor, Project>('PROJECT_EVENT_SEND');
